import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import {
  Button,
  FormContainer,
  FormSection,
  FloatingField,
  InputText,
  ChangePasswordDialog,
} from '../../components/aip';

/**
 * 設定ページ
 */
export const SettingsPage: React.FC = () => {
  const { user, logout } = useAuth();
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const handleLogout = () => {
    if (confirm('ログアウトしますか？')) {
      logout();
    }
  };

  const handlePasswordChangeSuccess = () => {
    setSuccessMessage('パスワードが正常に変更されました。');
    // 3秒後にメッセージを消す
    setTimeout(() => {
      setSuccessMessage(null);
    }, 3000);
  };

  return (
    <>
      <FormContainer>
        {/* 成功メッセージ */}
        {successMessage && (
          <div
            style={{
              padding: '1rem',
              backgroundColor: 'var(--color-success)',
              color: '#ffffff',
              borderRadius: '0.5rem',
              marginBottom: '1rem',
              fontSize: '0.875rem',
              fontWeight: 500,
            }}
          >
            {successMessage}
          </div>
        )}

        {/* アカウント情報 */}
        <FormSection title="アカウント情報">
          <FloatingField label="メールアドレス" htmlFor="email">
            <InputText
              id="email"
              name="email"
              value={user?.email || ''}
              disabled
            />
          </FloatingField>
          <FloatingField label="名前" htmlFor="name">
            <InputText
              id="name"
              name="name"
              value={user?.name || ''}
              disabled
            />
          </FloatingField>
        </FormSection>

        {/* セキュリティ */}
        <FormSection title="セキュリティ">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <p style={{ margin: '0 0 0.5rem', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                パスワードを変更する場合は、以下のボタンをクリックしてください。
              </p>
              <Button
                buttonType="outline"
                size="md"
                onClick={() => setIsPasswordDialogOpen(true)}
              >
                パスワードを変更
              </Button>
            </div>
          </div>
        </FormSection>

        {/* ログアウト */}
        <FormSection title="セッション">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <p style={{ margin: '0 0 0.5rem', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                現在のセッションからログアウトします。
              </p>
              <Button
                buttonType="outline"
                size="md"
                state="alert"
                onClick={handleLogout}
              >
                <span className="material-symbols-outlined">logout</span>
                ログアウト
              </Button>
            </div>
          </div>
        </FormSection>
      </FormContainer>

      {/* パスワード変更ダイアログ */}
      <ChangePasswordDialog
        open={isPasswordDialogOpen}
        onClose={() => setIsPasswordDialogOpen(false)}
        onSuccess={handlePasswordChangeSuccess}
      />
    </>
  );
};

export default SettingsPage;
